"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function() {
          this.state = {
              activeSort: false
            };
        },
        onInput: function(input) {
          this.state.activeSort = input.active || "grid";
        },
        onToggle: function(type) {
          this.state.activeSort = type;

          this.emit("change", type);
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/SortListControl/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Button_template = require("../Button/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Button_tag = marko_loadTag(Button_template),
    marko_attrs0 = {
        "class": "sort-list-control"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("span", marko_attrs0, "0", component);

  Button_tag({
      icon: "bxs-grid",
      class: "mr-1 font-large-1",
      activeClass: "mr-1 font-large-1 text-primary",
      state: state.activeSort == "grid" ? "active" : false
    }, out, __component, "1", [
    [
      "click",
      "onToggle",
      false,
      [
          "grid"
        ]
    ]
  ]);

  Button_tag({
      icon: "bx-list-ul",
      class: "mr-1 font-large-1",
      activeClass: "mr-1 font-large-1 text-primary",
      state: state.activeSort == "list" ? "active" : false
    }, out, __component, "2", [
    [
      "click",
      "onToggle",
      false,
      [
          "list"
        ]
    ]
  ]);

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
